<div class="row" *ngIf="itemKeys && itemKeys.length > 0">
  <div class="col-md-12 section-title" (click)="showMobile = !showMobile" *ngIf="!hideTitle">
    <h2><i class="app-icon-graph "></i><span style="white-space: nowrap">RAIOX TÉCNICO</span>
      <div class="d-md-none d-sm-block" style="width: 100%;">
        <i class="material-icons" style="float: right;">{{ showMobile ? 'expand_less' : 'expand_more'}}</i>
      </div>
    </h2>
    <br />
  </div>

  <div class="col-md-12 section-content mb-3 mb-md-0" class="show">
    <div class="row">
      <div class="col-md-12">
        <div class="row report-equipments" *ngIf="oldLayout">
          <div *ngFor="let report of itemKeys"
            class="col-md-4 col-sm-12 classification-{{reportItems[report].classification}}">
            <div class="row equipment-row">
              <div class="col-7 text-md-right equipment-name">
                <strong>{{getReportEquipLabel(report)}}</strong>
              </div>

              <div class="col-5 same-line">
                <div *ngIf="getTooltipText(report)" class="cursor-pointer" [matTooltip]="getTooltipText(report)"
                  matTooltipClass="equip-tooltip">
                  <i class="material-icons">{{getClassificationIcon(report) ||
                    'error'}}</i>{{getClassification(report)}}
                </div>
                <div *ngIf="!getTooltipText(report)">
                  <i class="material-icons">{{getClassificationIcon(report) ||
                    'error'}}</i>{{getClassification(report)}}
                </div>
                <div class="d-md-none d-sm-block">
                  <small>{{getDescriptionReport(report)}}</small>
                </div>
                <div class="d-md-none d-sm-block">
                  <span *ngIf="getValueReport(report)">
                    <small>Reparo: R$ {{getValueReport(report) | number: '1.2-2'}}</small>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row report-equipments" *ngIf="!oldLayout">
          <div *ngFor="let report of itemKeys" class="col-md-12 classification-{{reportItems[report].classification}}">
            <div class="row equipment-row b-border">
              <div class="equipment-name has-midia my-auto">
                <strong>{{getReportEquipLabel(report)}}</strong>
              </div>

              <div class="equipment-classification my-auto">
                <div *ngIf="getTooltipText(report)">
                  <i class="material-icons">{{getClassificationIcon(report) ||
                    'error'}}</i>{{getClassification(report)}}
                </div>
                <div *ngIf="!getTooltipText(report)">
                  <i class="material-icons">{{getClassificationIcon(report) ||
                    'error'}}</i>{{getClassification(report)}}
                </div>
                <div class="d-md-none d-sm-block">
                  <small>{{getDescriptionReport(report)}}</small>
                </div>
                <div class="d-md-none d-sm-block">
                  <span *ngIf="getValueReport(report)">
                    <small>Reparo: R$ {{getValueReport(report) | number: '1.2-2'}}</small>
                  </span>
                </div>
              </div>

              <div class="equipment-comment d-none d-md-block my-auto"
                style="flex: 0 0 20%; max-width: 20%; text-align: center;">
                <ng-container *ngIf="getTooltipDescriptionReport(report).length > 70; else elseBlock">
                  <span class="cursor-pointer" [matTooltip]="getTooltipDescriptionReport(report)" matTooltipClass="equip-tooltip">{{getDescriptionReport(report)}}</span>
                </ng-container>
                <ng-template #elseBlock>
                  {{getDescriptionReport(report)}}
                </ng-template>
                <img *ngIf="getDescriptionReport(report) === ''" src="../../../../../../assets/images/not.svg">
              </div>
              <div class="col-1 equipment-cost d-none d-md-block my-auto" style="text-align: center;"
                *ngIf="isEvaluation">
                {{getValueReport(report) | number: '1.2-2'}}
                <img *ngIf="getValueReport(report) === undefined" src="../../../../../../assets/images/not.svg">
              </div>
              <div class="col-3 my-auto" style="margin-left: 20px;" *ngIf="getGalleryImages(report).length > 0">
                <ngx-gallery [options]="galleryOptions" [images]="getGalleryImages(report)" class="ngx-gallery">
                </ngx-gallery>
              </div>
              <div class="col-3 my-auto" style="margin-left: 20px; text-align: center;"
                *ngIf="getGalleryImages(report).length === 0">
                <img src="../../../../../../assets/images/not.svg">
              </div>
              <div class="col-1 my-auto" style="flex: 0 0 7.4%;" *ngIf="hasAudio(report) && isEvaluation">
                <div class="row">
                  <i class="material-icons mx-auto" style="font-size: 32px; color: #16b097; display:block"
                    (click)="playAudio(report)">
                    {{thisAudioIsPlaying(report) ? 'stop_circle' : 'play_circle'}} </i>
                </div>
                <div class="row mt-1">
                  <span class="icon-description mx-auto">
                    {{thisAudioIsPlaying(report) ? 'Parar' : 'Ouvir'}}
                  </span>
                </div>
              </div>
              <div class="col-2 my-auto" style="flex: 0 0 14%;" *ngIf="hasAudio(report) && !isEvaluation">
                <div class="row">
                  <i class="material-icons mx-auto" style="font-size: 32px; color: #16b097; display:block"
                    (click)="playAudio(report)">
                    {{thisAudioIsPlaying(report) ? 'stop_circle' : 'play_circle'}} </i>
                </div>
                <div class="row mt-1">
                  <span class="icon-description mx-auto">
                    {{thisAudioIsPlaying(report) ? 'Parar' : 'Ouvir'}}
                  </span>
                </div>
              </div>
              <div class="col-1 my-auto" style="flex: 0 0 7.4%; text-align: center;"
                *ngIf="!hasAudio(report) && isEvaluation">
                <img src="../../../../../../assets/images/not.svg">
              </div>
              <div class="col-2 my-auto" style="flex: 0 0 14%; text-align: center;"
                *ngIf="!hasAudio(report) && !isEvaluation">
                <img src="../../../../../../assets/images/not.svg">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>